import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import NotFound from "../extras/NotFound";
import WithNavbar from "../extras/PrivateRouteWithNavbar"
import ResuppliesTable from '../tables/ResuppliesTable'

export default function Resupplies() {
    const match = useRouteMatch();
    return (
        <Switch>
            <WithNavbar exact path={match.path} component={ResuppliesTable} />
            <Route path="*" component={NotFound} />
        </Switch>
    )
}